import { IconButton, IconButtonProps, Tooltip, TooltipProps } from '@mui/material';
import React from 'react';

interface ActionButtonProps extends Omit<IconButtonProps, 'title'> {
     /**
      * Título do botão (exibido como tooltip)
      */
     title: string;

     /**
      * Ícone do botão
      */
     icon: React.ReactNode;

     /**
      * Props adicionais para o componente Tooltip
      */
     tooltipProps?: Omit<TooltipProps, 'title' | 'children'>;
}

/**
 * Componente de botão de ação reutilizável com tooltip
 */
const ActionButton: React.FC<ActionButtonProps> = ({ title, icon, tooltipProps, ...props }) => {
     return (
          <Tooltip
               title={title}
               {...tooltipProps}
          >
               <IconButton
                    size='small'
                    {...props}
               >
                    {icon}
               </IconButton>
          </Tooltip>
     );
};

export default ActionButton;
